import { gql } from "@apollo/client";

export const StarredInstalledBaseNodeList = gql`
    query StarredInstalledBaseNodeList(
        $pagination: Pagination
        $imageCrop: ResizeCrop
        $imageWidth: Int
        $imageHeight: Int
    ) {
        starredInstalledBaseNodeList {
            total
            installedBaseNodes(pagination: $pagination) {
                id
                title
                isStarred
                nodeType {
                    id
                    key
                    name
                }
                owner {
                    id
                    name
                    industryType
                }
                pathNodes {
                    id
                    title
                    nodeType {
                        id
                        key
                    }
                }
                image {
                    id
                    file {
                        id
                        thumbnailLink(crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                    }
                }
                assetLocation {
                    id
                    asset {
                        id
                        serialNumber
                        product {
                            id
                            name
                            productCode
                            image {
                                id
                                thumbnailLink(crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                            }
                        }
                    }
                }
                system {
                    id
                    systemType
                }
            }
        }
    }
`;
